import React from 'react';
import { Phone, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const LogItem = ({ log }) => {
  const sent = log.status === 'sent';
  return (
    <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-testid={`sms-log-${log.id}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <Phone className="w-4 h-4 text-cyan-400" />
          <span className="text-white font-medium">{log.customer_name || log.phone}</span>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${sent ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
          {sent ? '✓ Sent' : '◉ Demo'}
        </span>
      </div>
      <p className="text-gray-400 text-sm line-clamp-2">{log.message}</p>
      <p className="text-gray-600 text-xs mt-2">{new Date(log.sentAt).toLocaleString()}</p>
    </div>
  );
};

export const SmsHistory = ({ logs }) => (
  <Card className="bg-gray-900 border-gray-800 mt-6" data-testid="sms-history">
    <CardHeader>
      <CardTitle className="text-white flex items-center">
        <Clock className="w-5 h-5 mr-2 text-yellow-400" />
        Recent Messages
      </CardTitle>
    </CardHeader>
    <CardContent>
      {logs.length === 0 ? (
        <p className="text-gray-500 text-center py-4">No messages sent yet</p>
      ) : (
        <div className="space-y-3 max-h-64 overflow-y-auto">
          {logs.map((log) => <LogItem key={log.id} log={log} />)}
        </div>
      )}
    </CardContent>
  </Card>
);
